import { SvgIcon } from '@progress/kendo-react-common';
import { useAppSelector } from '../../../app/hooks/store-hooks';
import commonFormatter from '../../../formatters/common-formatter';
import { ArrowRightOutline } from '../../../icons/icons';
import { CityPairTooltipData } from '../../../services/map-interaction-service';

export function CityPairTooltip(props: { info: CityPairTooltipData }) {
    const displayStyle = useAppSelector((x) => x.settings.airportIdDisplayStyle);
    const context = props.info;

    return context.items.map((item, i) => (
        <div className="p-2" key={i} style={{ fontSize: 12, maxWidth: 400 }}>
            <div style={{ fontWeight: 'bold' }} className="d-flex align-items-center">
                {commonFormatter.formatAirportId(item.from, displayStyle)}
                <SvgIcon icon={ArrowRightOutline} />
                {commonFormatter.formatAirportId(item.to, displayStyle)}
            </div>
            <div>
                {item.flights.map((x, i) => (
                    <div key={i}>{x}</div>
                ))}
            </div>
        </div>
    ));
}
